module.exports = __webpack_public_path__ + "img/art4.50eace40.png";